import { useState } from "react";
import Field from "../../../DesignSystem/Inputs/Field";
import CustomSelect from "../../../DesignSystem/Dropdowns/CustomSelect";
import { PASSPORT_RELATIONSHIP_OPTIONS } from "../../Constants/PassportRelationships";
import FileUpload from "../../../DesignSystem/Upload/FileUpload";
import UploadedFileList from "../../../DesignSystem/Upload/UploadedFileList";
import IconButton from "../../../DesignSystem/Buttons/IconButton";
import { ReactComponent as AddIcon } from "../../../../assets/icons/add.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { PostCard } from "../HelperFunctions/HelperFunctions";
import { getEditablePassportEntries, validatePassportImages } from "../../../../context/Adviser/Utils/passportImages";

export default function EditPassportDetails({ form, setForm, saving }) {
  const [errors, setErrors] = useState({});
  const passports = getEditablePassportEntries(form.adviserDoc, form.personalDetails);
  const change = (id, patch) => setForm(current => ({...current, adviserDoc: {...current.adviserDoc,
    passports: getEditablePassportEntries(current.adviserDoc, current.personalDetails).map(passport => passport.id === id ? {...passport, ...patch} : passport)}}));
  const addImages = (passport, files) => {
    try {
      const pending = form.passportImageFilesById?.[passport.id] || [];
      validatePassportImages(passport.images || [], [...pending, ...files]);
      setForm(current => ({...current, passportImageFilesById: {...current.passportImageFilesById,
        [passport.id]: [...(current.passportImageFilesById?.[passport.id] || []), ...files]}}));
      setErrors(current => ({...current, [passport.id]: ""}));
    } catch (error) { setErrors(current => ({...current, [passport.id]: error.message})); }
  };
  const removePassport = passport => setForm(current => {
    const pending = {...current.passportImageFilesById};
    delete pending[passport.id];
    return {...current, passportImageFilesById: pending,
      passportImagesToDelete: [...(current.passportImagesToDelete || []), ...(passport.images || [])],
      adviserDoc: {...current.adviserDoc, passports: getEditablePassportEntries(current.adviserDoc, current.personalDetails).filter(entry => entry.id !== passport.id)}};
  });
  const addPassport = () => setForm(current => ({...current,
    adviserDoc: {...current.adviserDoc, passports: [...getEditablePassportEntries(current.adviserDoc, current.personalDetails),
      {id: crypto.randomUUID(), holderName: "", relationship: "", expiryDate: "", images: []}]}}));
  return <PostCard title="Passport Details" right={
    <IconButton icon={<AddIcon />} label="Add passport" disabled={saving} onClick={addPassport} />
  }><div className="fit-column gap-m">
    {passports.map((passport, passportIndex) => {
      const images = passport.images || [];
      const pending = form.passportImageFilesById?.[passport.id] || [];
      return <div key={passport.id} className="fit-column gap-m" style={{border: "1px solid var(--Grey10)", borderRadius: 6, padding: 16}}>
        <div className="profileActionsRow" style={{justifyContent: "space-between"}}>
          <div className="FP_Body_Semibold">{passport.isSelf ? "Self" : `Passport ${passportIndex + 1}`}</div>
          {!passport.isSelf ? <IconButton icon={<DeleteIcon />} label="Delete passport" disabled={saving} onClick={() => removePassport(passport)} /> : null}
        </div>
        <div className="smGrid2">
          <Field label="Passport holder name" value={passport.holderName || ""} disabled={saving}
            readOnly={passport.isSelf}
            onChange={holderName => change(passport.id, {holderName})} />
          {!passport.isSelf ? <CustomSelect label="Relationship / Role" value={passport.relationship || ""}
            placeholder="Select relationship / role"
            options={passport.relationship && !PASSPORT_RELATIONSHIP_OPTIONS.some(option => option.id === passport.relationship)
              ? [...PASSPORT_RELATIONSHIP_OPTIONS, {id: passport.relationship, name: passport.relationship}]
              : PASSPORT_RELATIONSHIP_OPTIONS}
            disabled={saving} onChange={event => change(passport.id, {relationship: event.target.value})} /> : null}
          <Field label="Passport expiry date" type="date" value={passport.expiryDate || ""}
            disabled={saving} onChange={expiryDate => change(passport.id, {expiryDate})} />
        </div>
        <FileUpload label="Passport attachments" accept="image/jpeg,image/png,image/webp,application/pdf" multiple
          description="Upload up to three attachments for this passport (10 MB per file)"
          disabled={saving || images.length + pending.length >= 3} onFilesChange={files => addImages(passport, files)}
          status={errors[passport.id] ? "error" : "default"} statusMessage={errors[passport.id]} />
        {errors[passport.id] ? <p className="Content-Small" role="alert">{errors[passport.id]}</p> : null}
        {images.length > 0 ? <UploadedFileList files={images} removable={!saving} onRemove={(_, index) => {
          setForm(current => ({...current, passportImagesToDelete: [...(current.passportImagesToDelete || []), images[index]],
            adviserDoc: {...current.adviserDoc, passports: getEditablePassportEntries(current.adviserDoc, current.personalDetails).map(entry => entry.id === passport.id
              ? {...entry, images: images.filter((_, i) => i !== index)} : entry)}}));
        }} /> : null}
        {pending.length > 0 ? <UploadedFileList files={pending.map((file, index) => ({name: file.name, id: `pending-${index}`}))}
          removable={!saving} onRemove={(_, index) => setForm(current => ({...current,
            passportImageFilesById: {...current.passportImageFilesById, [passport.id]: pending.filter((_, i) => i !== index)}}))} /> : null}
        <p className="Content-Small muted">{images.length + pending.length} of 3 attachments selected.</p>
      </div>;
    })}
    {!passports.length ? <p className="Content-Small muted">No passports added.</p> : null}
  </div></PostCard>;
}
